import React from 'react';
import { Suspense, lazy } from 'react';
import { connect } from 'react-redux';

// PageElements
import ReduxManager from 'components/v2/PageElements/ReduxManager';
import Route, { Switch } from 'components/v2/PageElements/Routes';

// Redux State Mappers
import { mapPermissionsToProps } from 'mappers/v1/permissions';

// Config
import paths from 'config/paths/facilities';

// Components
const Index = lazy(() => import('./index'));
const ResourceLayout = lazy(() => import('./ResourceLayout'));

export const Routes = ({ paths, permissions }) => {
  return (
    <ReduxManager data={['peopleDropdown', 'tagNamesDropdown']}>
      <Suspense fallback={<></>}>
        <Switch>
          <Route permission={permissions.facilities.list} exact path={paths.root}>
            <Index paths={paths} />
          </Route>
          <Route permission={permissions.facilities.list} path={paths.resource.root}>
            <ResourceLayout paths={paths} />
          </Route>
        </Switch>
      </Suspense>
    </ReduxManager>
  );
};

export default connect(mapPermissionsToProps, null)((props) => <Routes paths={paths} {...props} />);
